function addOriginalParams(url) {
  var originalSearchParams = new URLSearchParams(window.location.search);
  var searchParamsWithoutAlgolia = new URLSearchParams();
  originalSearchParams.forEach(function(value, key) {
    if (key != "q" && key != "sortBy" && key != "page" && key.indexOf('refinementList') == -1) {
      searchParamsWithoutAlgolia.append(key, value);
    }
  });
  questionMarkSearch = url.indexOf('?');
  var algoliaParams;
  var urlNoParams;
  if (questionMarkSearch == -1) {
    algoliaParams = new URLSearchParams();
    urlNoParams = url;
  } else {
    algoliaParams = new URLSearchParams(url.slice(questionMarkSearch + 1));
    urlNoParams = url.slice(0, questionMarkSearch);
  }
  searchParamsWithoutAlgolia.forEach(function(value, key) {
    algoliaParams.append(key, value);
  });
  if (algoliaParams.toString().length > 0) {
    return urlNoParams + '?' + algoliaParams.toString();
  } else {
    return urlNoParams;
  }
}
(function(algolia) {
  "use strict";

  algolia.externals = {
    // Export the required librarires
    Hogan: window.Hogan,
    instantsearch: window.instantsearch,
    algoliasearch: window.algoliasearch,
    autocomplete: window.autocomplete,
    aa: window.AlgoliaAnalytics.default,

    // Export the required widgets
    widgets: {
      menu: window.instantsearch.widgets.menu,
      refinementList: window.instantsearch.widgets.refinementList,
      searchBox: window.instantsearch.widgets.searchBox,
      stats: window.instantsearch.widgets.stats,
      sortBy: window.instantsearch.widgets.sortBy,
      clearRefinements: window.instantsearch.widgets.clearRefinements,
      panel: window.instantsearch.widgets.panel,
      hits: window.instantsearch.widgets.hits,
      pagination: window.instantsearch.widgets.pagination,
      configure: window.instantsearch.widgets.configure,
      ratingMenu: window.instantsearch.widgets.ratingMenu,
      queryRuleCustomData: window.instantsearch.widgets.queryRuleCustomData,
      // Define any new widgets here...
      configureRelatedItems: window.instantsearch.widgets.EXPERIMENTAL_configureRelatedItems,
      rangeSlider: window.instantsearch.widgets.rangeSlider
    },

    // Export InstantSearch connectors
    connectors: {
      connectCurrentRefinements: instantsearch.connectors.connectCurrentRefinements,
      connectRefinementList: instantsearch.connectors.connectRefinementList
    },
  };
})(window.algoliaShopify);